var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapMap',{ref:"googleMaps",staticStyle:{"height":"100%","width":"100%"},attrs:{"center":_vm.center,"zoom":_vm.zoom,"map-type-id":_vm.mapType,"options":_vm.options}},[(_vm.renderLine)?_c('div',[(_vm.dot && !_vm.overlayAllData)?_c('div',_vm._l((_vm.normalizedData),function(path,index){return _c('gmap-circle',{key:("circle_" + index),attrs:{"center":path,"radius":4,"visible":true,"options":{
            fillColor:
              _vm.strokeColors[
                path.value < _vm.lowerLimit ? 0 : path.value > _vm.upperLimit ? 2 : 1
              ],
            fillOpacity: 1.0,
            strokeColor: _vm.strokeColors[path.value - 1],
            strokeOpacity: 0.0,
          }},on:{"click":function($event){_vm.panToLocation(path);
            _vm.$emit('dotClicked', index);}}})}),1):_vm._e(),(_vm.dot && _vm.overlayAllData)?_c('div',_vm._l((_vm.profileData),function(survey,index){return _c('div',{key:("circleSurvey_" + index)},_vm._l((survey),function(path,index){return _c('gmap-circle',{key:("circle_" + index),attrs:{"center":path,"radius":4,"visible":true,"options":{
              fillColor:
                _vm.strokeColors[
                  path.value < _vm.lowerLimit
                    ? 0
                    : path.value > _vm.upperLimit
                    ? 2
                    : 1
                ],
              fillOpacity: 1.0,
              strokeColor: _vm.strokeColors[path.value - 1],
              strokeOpacity: 0.0,
            }},on:{"click":function($event){_vm.panToLocation(path);
              _vm.$emit('dotClicked', index);}}})}),1)}),0):_vm._e(),(_vm.currentPosition.length > 0)?_c('div',_vm._l((_vm.currentPosition),function(path,index){return _c('gmap-circle',{key:("cp_" + index),attrs:{"center":path,"radius":6,"visible":true,"options":{
            fillColor: 'black',
            fillOpacity: 1.0,
            strokeOpacity: 0.0,
          }}})}),1):_vm._e(),(_vm.currentRange.length > 0 && _vm.showRangeCircles)?_c('div',_vm._l((_vm.currentRange),function(path,index){return _c('gmap-circle',{key:("cr_" + index),attrs:{"center":path,"radius":8,"visible":true,"options":{
            fillColor: '#5491f5',
            fillOpacity: 0.8,
            strokeOpacity: 0.0,
          }}})}),1):_vm._e(),(_vm.polyline)?_c('div',_vm._l((_vm.paths),function(path,index){return _c('gmap-polyline',{key:("line_" + index),attrs:{"path":path,"options":{
            strokeColor:
              _vm.strokeColors[
                path[0].value < _vm.lowerLimit
                  ? 0
                  : path[0].value > _vm.upperLimit
                  ? 2
                  : 1
              ],
          }},on:{"click":function($event){return _vm.returnFalse()}}})}),1):_vm._e(),(_vm.clustorMarkers != null)?_c('div',[_c('gmap-cluster',{ref:"cluster",attrs:{"gridSize":30,"zoomOnClick":true,"enableRetinaIcons":true,"minimumClusterSize":10},on:{"click":_vm.handleClusterClick}},_vm._l((_vm.clustorMarkers),function(m,index){return _c('gmap-marker',{key:index,ref:("marker_" + (m.data.id)),refInFor:true,attrs:{"position":m,"clickable":true,"draggable":false,"icon":m.icon
                ? m.icon
                : 'https://simple-software-tools.s3.ap-southeast-2.amazonaws.com/map-icons/mapicon-red-resized.png',"title":m.data.id},on:{"click":function($event){_vm.$emit('updatePos', m);
              _vm.$emit('showMarkers', [m.data.id]);}}})}),1)],1):_vm._e()]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }